<template>
	<div v-if="active">
		<footer id="footer" class="footer">
			<newsletter-subscribe
				v-if="((!user || user.email.includes('guest.quomi.it')) && $mq.isOnline)"
			/>
			<div class="flex">
				<div class="widget">

					<h3>{{ $t("components.footer.navigation_widget.title") }}</h3>

					<div class="contacts">
						<router-link
							:to="{name: 'our-team'}"
							:title='`Chi siamo`'
							class='nav-item tag-partner'
						>
							{{ $t("components.navigation.links.quomi_team") }}
						</router-link>

						<router-link
							:to="{name: 'invite-friend'}"
							class='nav-item tag-partner'
						>
							{{ $t("components.navigation.links.invite_friend") }}
						</router-link>

						<router-link
							:to="{name: 'how-it-works'}"
							:title='$t("components.navigation.footer.how_it_works")'
						>
							{{ $t("components.navigation.footer.how_it_works") }}
						</router-link>

						<router-link
							:to="{name: 'how-we-recycle'}"
							:title='$t("components.navigation.footer.box_shipment")'
						>
							{{ $t("components.navigation.footer.box_shipment") }}
						</router-link>

						<router-link
							:to="{name: 'suppliers'}"
              class='tag-partner'
							:title='$t("components.navigation.footer.suppliers")'
						>
							{{ $t("components.navigation.footer.suppliers") }}
						</router-link>

						<router-link
							:to="{name: 'faq'}"
							:title='$t("components.navigation.footer.faq")'
						>
							{{ $t("components.navigation.footer.faq") }}
						</router-link>

						<router-link
							:to="{name: 'cookbook'}"
              class='tag-partner'
							:title='$t("components.navigation.footer.cookbook")'
						>
							{{ $t("components.navigation.footer.cookbook") }}
						</router-link>

						<!--<router-link
							:to="{name: 'shop'}" 
              class='tag-partner'
							:title='$t("components.navigation.footer.shop")'
						>
							{{ $t("components.navigation.footer.shop") }}
						</router-link>-->

						<router-link
							:to="{name: 'gift-card'}"
              class='tag-partner'
							:title='$t("components.navigation.footer.gift_card")'
						>
							{{ $t("components.navigation.links.gift_card") }}
						</router-link>

						<router-link
							:to="{name: 'landing-b2b'}"
              class='tag-partner'
						>
							Per le aziende
						</router-link>
					</div>
				</div>

				<div class="widget">
					<div>
						<h3>{{ $t("components.footer.contacts_widget.title") }}</h3>
						<ul class="contacts">
							<li v-if="$root.source === 'bennet'">
								<a href="tel:0287156618" title="Tel: 02 87 15 66 18">
									{{ $t("components.footer.contacts_widget.phone_number_bennet") }}
								</a>
								<span class="time">{{ $t("components.footer.contacts_widget.week_days") }}
									<nobr>{{ $t("components.footer.contacts_widget.time") }}</nobr>
								</span>
							</li>

							<li v-else>
								<a href="tel:0280889266" title="Tel: 02 80 88 92 66">
									{{ $t("components.footer.contacts_widget.phone_number") }}
								</a>
								<span class="time">{{ $t("components.footer.contacts_widget.week_days") }}
									<nobr>{{ $t("components.footer.contacts_widget.time") }}</nobr>
								</span>
							</li>

							<li class="tag-partner">
								<a :href="'mailto:' + $t('components.footer.contacts_widget.email')" :title='$t("components.footer.contacts_widget.email")'>
									{{ $t("components.footer.contacts_widget.email") }}
								</a>
							</li>
							<li v-if="$root.source === 'bennet'">
								<a :href="'mailto:instacook@quomi.it'" title='"instacook@quomi.it'>
									instacook@quomi.it
								</a>
							</li>
							<li class="tag-partner">
								<a target="_blank" href="https://api.whatsapp.com/send?phone=390280889266" style="text-decoration: none">
									<v-btn
										rounded
										color="#4AC959"
										class="white--text"
									>
										<v-icon left light>fab fa-whatsapp</v-icon>
										Scrivici su Whatsapp
									</v-btn>
								</a>
							</li>
						</ul>
					</div>

					<div class="tag-partner">
						<h3>{{ $t("components.footer.followus_widget.title") }}</h3>
						<div class="socials-seguici flex flex-center">

							<a :href='$t("components.footer.followus_widget.links.blog")' target="_blank" class="blog-link" title="Blog Quomi">
								<div class="icon-blog">
									<span class="blog">Blog</span>
								</div>
							</a>&ensp;

							<a :href='$t("components.footer.followus_widget.links.facebook")' target="_blank" title="Facebook Quomi">
								<i id="social-facebook" class="fa fa-facebook-square fa-4x social-facebook"></i>
							</a>&ensp;

							<a :href='$t("components.footer.followus_widget.links.instagram")' target="_blank" title="Instagram Quomi">
								<i id="social-instagram" class="fa fa-instagram fa-4x social-instagram"></i>
							</a>&ensp;

							<a :href='$t("components.footer.followus_widget.links.youtube")' target="_blank" title="YouTube Quomi">
								<i class="fab fa-youtube-square fa-2x"></i>
							</a>&ensp;

							<a :href='$t("components.footer.followus_widget.links.tiktok")' target="_blank" title="TikTok Quomi">
								<img class="tiktok-logo" src="https://api.quomi.it/oldimg/output-onlinepngtools-%282%29.png" alt="TikTok Quomi" width="42px">
							</a>&ensp;
						</div>
					</div>
				</div>

				<div class="widget feedaty-widge tag-partner">
					<feedaty
						isBig
					/>
				</div>

				<div>
					<div>
						<h3>Partner di</h3>

						<a href="http://www.consorzionetcomm.it/associazione/chi-siamo/soci/elenco_soci/quomi.kl" target="_blank">
							<img src="../assets/img/netcomm.png">
						</a>

						<br>
						<router-link :to="{ name: 'edenTree' }">
							<img src="../assets/img/content/eden-logo.png">
						</router-link>
					</div>

					<div class='tag-partner'>
						<h3>Scarica L'APP</h3>
						<div>
							<a href='https://play.google.com/store/apps/details?id=it.quomi.quomihybridapp&utm_source=sito&utm_campaign=sito&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'>
								<img alt='Disponibile su Google Play' src='../assets/img/googleplaystore.png'/>
							</a>
						</div>
					</div>
				</div>
			</div>

			<div class="flex flex-column align-items-center tag-partner mt-5">
				<h3>{{ $t("components.footer.payment_methods.title") }}</h3>
				<div class="flex">
					<i class='fab fa-cc-visa fa-3x mr-2'/>
					<i class='fab fa-cc-mastercard fa-3x mr-2'></i>
					<i class='fab fa-cc-paypal fa-3x mr-2'></i>
					<span class="postepay mr-2"></span>
					<span class="edenred"></span>
					<span class="pellegrini ml-2"></span>
          <span class="applepay  ml-2"></span>
				</div>
			</div>
			
		</footer>

		<bottom-bar />

	</div>
</template>

<script>

import NewsletterSubscribe from '../components/Parts/NewsletterSubscribe'
import BottomBar from '../components/Parts/BottomBar'
import Feedaty from '@/components/Feedaty'
import { container } from '../services/container'

export default {
	components: {
		BottomBar,
		Feedaty,
		NewsletterSubscribe
	},

	computed: {
		user () {
			return this.$root.user
		},
		active () {
			return this.$route.meta.footer !== false
		}
	}
}
</script>

<style scoped>
	h3 {
		font-size: 24px;
		text-align: center;
	}

	#footer {
		padding: 30px 0;
		position: relative;
		background-color: #575A5C;
		background-repeat: no-repeat;
		background-position: center center;
		color: #ededed;
		text-align: center;
	}

	h1,
	h2,
	h3,
	h4,
	h5 {
		color: #ededed;
	}

	img {
		margin: auto;
	}

	#footer > div.flex {
		max-width: 1024px;
		justify-content: space-between;
		margin: 0 auto;
	}

	.widget > div + div {
		margin-top: 20px;
	}

	ul {
		list-style: none;
		margin: 0 0 10px 0;
	}

	ul li {
		margin-top: 5px;
		position: relative;
		color: #9a9a9a;
		font-size: 14px;
	}

	.contacts .time {
		font-size: 13px;
	}

	.contacts  a {
		color: #ffffff;
		display: block;
	}

	.contacts a:hover {
		color: #ffffff;
		text-decoration: underline;
	}

	.footer-logos {
		display: block;
		max-height: 45px;
		max-width: 160px;
	}

	.icon-blog {
		background-color: white;
		font-size: 14px;
		border-radius: 6px;
		width: 35px;
		height: 35px;
		display: inline-block;
		vertical-align: top;
		color: grey;
	}

	.blog-link:hover {
		color: grey;
	}

	.gray {
		-webkit-filter: grayscale(100%); filter: grayscale(100%);
	}

	.postepay,
	.edenred,
	.pellegrini,
  .applepay {
		width: 50px;
		height: 40px;
		margin-top: 2px;
		border-radius: 3px;
		background-repeat: no-repeat;
		background-size: cover;
	}

  .applepay {
    background-image: url("https://api.quomi.it/oldimg/apple-pay.png");
    width: 61px;
  }

	.postepay {
		background-image: url("https://api.quomi.it/oldimg/postepay51.png");
	}

	.edenred {
		background-image: url("https://api.quomi.it/oldimg/tredenred.png");
	}

	.pellegrini {
		background-image: url('https://api.quomi.it/oldimg/Pellgrini-quomi-logo-2.png');
	}

	.whatsapp {
		border-radius: 15px; 
		border: 4px solid #383232; 
		padding: 5px; display: inline-flex; 
		align-items: center; 
		max-width: max-content; 
		min-width: 160px
	}

	@media only screen and (max-width: 1024px) {
		.widget {
			order: 2;
		}

		.feedaty-widget {
			order: 1;
		}

		#footer .flex {
			flex-wrap: wrap;
			justify-content: center;
		}

		#footer .flex > div{
			width: 100%;
			margin-bottom: 22px;
		}
	}

	span.blog {
		vertical-align: text-bottom;
		line-height: 2.4;
	}

	.icon-blog:hover {
		background-color: yellow;
	}

	.social-blog {
		color: #ffffff;
	}

	.social-blog:hover {
		color: yellow;
	}

	.social-facebook {
		color: #ffffff;
		font: normal normal normal 41px/0.9 FontAwesome !important;
	}

	.social-facebook:hover {
		color: #6d84b4;
	}

	.social-pinterest {
		background-color: #ffffff;
	}

	.social-pinterest:hover {
		background-color: #B61C23;
	}

	.social-instagram {
		color: #ffffff;
		font: normal normal normal 41px/0.9 FontAwesome !important;
	}

	.social-instagram:hover {
		color: #fbad50;
	}

	.fa-youtube-square {
		color: #ffffff;
		font-size: 39px;
	}

	.fa-youtube-square:hover {
		color: #bb0000;
	}

	.tiktok-logo:hover {
		background-color: #ff0050;
	}


</style>
